import { GOOGLE_MAPS_KEY } from '@/config';

const CALLBACK_PROP = 'googleMapInit';

let setup = false;

export const apiLoaded = new Promise((resolve) => {
  window[CALLBACK_PROP] = resolve;
});

function getBaseApiUrl() {
  return 'https://maps.googleapis.com/maps/api';
}

function createOptionsString(options) {
  const optionsWithKey = {
    key: GOOGLE_MAPS_KEY,
    ...options,
  };
  return Object.keys(optionsWithKey)
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(optionsWithKey[k])}`)
    .join('&');
}

export function load(opts) {
  if (setup) {
    return apiLoaded;
  }

  const options = opts || {};
  const googleMapScript = document.createElement('script');

  // Append libraries
  if (Array.isArray(options.libraries)) {
    options.libraries = options.libraries.join(',');
  }
  options.callback = CALLBACK_PROP;

  const optionsString = createOptionsString(options);
  const url = `${getBaseApiUrl()}/js?${optionsString}`;

  googleMapScript.setAttribute('src', url);
  googleMapScript.setAttribute('async', '');
  googleMapScript.setAttribute('defer', '');
  document.head.appendChild(googleMapScript);

  // Mark setup as true so that multiple scripts do not get appended
  setup = true;
  return apiLoaded;
}

export async function findPlaces({
  searchString,
  mapBounds,
} = {}) {
  const geocoder = new google.maps.Geocoder();

  return new Promise((resolve, reject) => {
    const params = {
      address: searchString,
    };

    if (mapBounds) {
      const sw = mapBounds.getSouthWest();
      const ne = mapBounds.getNorthEast();
      params.bounds = new google.maps.LatLngBounds(
        { lat: sw.lat, lng: sw.lng },
        { lat: ne.lat, lng: ne.lng },
      );
    }

    geocoder.geocode(params, (results, status) => {
      if (status === 'OK') {
        const places = results.map((place) => {
          const point = place.geometry.location;
          const location = { lat: point.lat(), lng: point.lng() };
          return {
            label: place.formatted_address,
            location,
          };
        });
        return resolve(places);
      }

      return reject(new Error(status));
    });
  });
}
